var $ = require('lib/bling');
var ga = window.ga || function() {};

// ......................
// === Takeover Class ===
// ^^^^^^^^^^^^^^^^^^^^^^
var Takeover = function({el, open, close}) {
	this.$el = $(el);
	this.$open = $(open);
	this.$close = $(close);
	this.initialize();
};

Takeover.prototype.initialize = function() {
	this.$open.on('click', (el) => {
		this.$el[0].classList.add('show-takeover');
		ga('send', 'event', 'takeover', 'open', 'click');
	});

	this.$close.on('click', (el) => {
		this.$el[0].classList.remove('show-takeover');
		ga('send', 'event', 'takeover', 'close', 'click');
	});
};

module.exports = Takeover;


// WEBPACK FOOTER //
// ./src/takeover.js